<template>
  <v-form>
    <v-row class="elevation-0">
      <v-col>
        <toolsServices v-if="statusTools" v-on:AccionMenu="AccionMenu" />
      </v-col>
    </v-row>
    <v-row v-if="statusReports">
      <v-col>
        <reports v-if="statusReports" v-on:AccionMenu="AccionMenu" />
      </v-col>
    </v-row>

    <v-row v-if="statusSalesTax">
      <v-col>
        <sale v-if="statusSalesTax" :estatus="true" />
      </v-col>
    </v-row>

    <v-row v-if="statusChecks">
      <v-col>
        <Checks v-if="statusChecks" />
      </v-col>
    </v-row>

    <v-row v-if="statusReportsPayroll">
      <v-col>
        <ReportsPayroll v-if="statusReportsPayroll" />
      </v-col>
    </v-row>

    <v-row v-if="statusForms">
      <v-col>
        <Forms v-if="statusForms" />
      </v-col>
    </v-row>

    <v-row v-if="statusOthers">
      <v-col>
        <Others v-if="statusOthers" />
      </v-col>
    </v-row>

    <v-row v-if="statusEmployee">
      <v-col>
        <Employee v-if="statusEmployee" />
      </v-col>
    </v-row>

    <v-row v-if="statusTaxReturn">
      <v-col>
        <TaxReturn v-if="statusTaxReturn" />
      </v-col>
    </v-row>

    <v-row v-if="statusBooks">
      <v-col>
        <Books v-if="statusBooks" />
      </v-col>
    </v-row>

    <v-row v-if="statusCompanyInfo">
      <v-col>
        <CompanyInfo v-if="statusCompanyInfo" />
      </v-col>
    </v-row>

    <v-row v-if="statusVendors">
      <v-col>
        <Vendors v-if="statusVendors" />
      </v-col>
    </v-row>

    <v-row v-if="statusCompanyFolder">
      <v-col>
        <CompanyFolder v-if="statusCompanyFolder" />
      </v-col>
    </v-row>

    <v-row v-if="statusEFTPS">
      <v-col>
        <EFTPS v-if="statusEFTPS" />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <Excel
          v-if="dialogoArchivo"
          :estatus="dialogoArchivo"
          @cerrar="CerrarDialogo"
          @abrir="AbrirDialogoDescarga"
        />

        <Download :estatus="dialogoDescarga" @cerrar="CerrarDialogoDescarga" />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <tablaClientes v-if="statusTools == false" v-on:show="showTools" />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import toolsServices from "../components/toolsServices";
import tablaClientes from "../components/TablaClientes";
import reports from "../components/Reports";
import sale from "../components/salestax";
import Checks from "../components/Checks.vue";
import ReportsPayroll from "../components/ReportsPayroll";
import Forms from "../components/Forms";
import Others from "../components/Others";
import Employee from "../components/EmployeeInfo";
import TaxReturn from "../components/TaxReturn";
import Books from "../components/Books";
import CompanyInfo from "../components/CompanyInfo.vue";
import Vendors from "../components/Vendors.vue";
import CompanyFolder from "../components/CompanyFolders.vue";
import EFTPS from "../components/EFTPS.vue";

import EventBus from "../bus";
import main from "../App";
import Excel from "../components/HerramientaExcel"; //Componente para modificar el archivo de excel
import Download from "../components/DescargarExcel"; //Componente para descargar el archivo de excel ya modificado

export default {
  components: {
    toolsServices,
    tablaClientes,
    sale,
    reports,
    main,
    Excel,
    Download,
    Checks,
    ReportsPayroll,
    Forms,
    Others,
    Employee,
    TaxReturn,
    Books,
    CompanyInfo,
    Vendors,
    CompanyFolder,
    EFTPS
  },
  data: () => ({
    statusEFTPS: false,
    statusCompanyFolder: false,
    statusVendors: false,
    statusCompanyInfo: false,
    statusBooks: false,
    statusTaxReturn: false,
    tabla: true,
    statusTools: false,
    statusSalesTax: false,
    statusReports: false,
    dialogoArchivo: false,
    dialogoDescarga: false,
    statusChecks: false,
    statusReportsPayroll: false,
    statusForms: false,
    statusOthers: false,
    statusEmployee: false,
  }),
  created: function () {
    EventBus.$on("reload-table", () => {
      //alert("funciona?");
      this.statusCompanyFolder = false;
      this.statusTools = false;
      this.statusSalesTax = false;
      this.statusReports = false;
      this.statusChecks = false;
      this.statusReportsPayroll = false;
      this.statusForms = false;
      this.statusOthers = false;
      this.dialogoArchivo = false;
      this.statusEmployee = false;
      this.statusTaxReturn = false;
      this.statusVendors = false;
      this.statusCompanyInfo = false;
      this.statusBooks = false;
      this.statusEFTPS = false;
    });
  },
  mounted() {
    this.tabla = true;
    this.statusSalesTax = false;
    this.statusTools = false;
    EventBus.$emit("hint-taskcenter");
  },
  methods: {
    CerrarDialogoDescarga() {
      this.dialogoDescarga = false;
    },
    CerrarDialogo() {
      this.dialogoArchivo = false;
    },
    AbrirDialogoDescarga() {
      this.dialogoDescarga = true;
    },
    CerrarDialogoChat() {
      this.dialogoChat = false;
      this.validarChat = false;
    },
    showTools() {
      this.statusTools = true;
    },
    AccionMenu: function (className) {
      console.log(className);
      switch (className) {
        case "Excel Editor":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.dialogoArchivo = true;
          this.statusSalesTax = false;
          this.statusReports = false;
          this.statusChecks = false;
          this.statusReportsPayroll = false;
          this.statusForms = false;
          this.statusOthers = false;
          this.statusEmployee = false;
          this.statusCompanyInfo = false;
          this.statusTaxReturn = false;
          this.statusBooks = false;
          this.statusEFTPS = false;
          break;

        case "Sales Taxes":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.tabla = false;
          this.statusSalesTax = true;
          this.statusBooks = false;
          this.statusReports = false;
          this.statusChecks = false;
          this.statusReportsPayroll = false;
          this.statusForms = false;
          this.statusTaxReturn = false;
          this.statusOthers = false;
          this.statusCompanyInfo = false;
          this.statusEFTPS = false;
          this.statusEmployee = false;
          break;

        case "Bookkeeping":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.tabla = false;
          this.statusChecks = false;
          this.statusEmployee = false;
          this.statusCompanyInfo = false;
          this.statusTaxReturn = false;
          this.statusEFTPS = false;
          this.statusBooks = false;
          this.$router.push("/Bookkeeping").catch((failure) => {});
          break;

        case "Vendors":
          this.statusCompanyFolder = false;
          this.statusVendors = true;
          this.statusReports = false;
          this.tabla = false;
          this.statusBooks = false;
          this.statusSalesTax = false;
          this.statusChecks = false;
          this.statusReportsPayroll = false;
          this.statusEFTPS = false;
          this.statusForms = false;
          this.statusOthers = false;
          this.statusTaxReturn = false;
          this.statusEmployee = false;
          this.statusCompanyInfo = false;
          break;

        case "Folders":
          this.statusCompanyFolder = true;
          this.statusVendors = false;
          this.statusReports = false;
          this.tabla = false;
          this.statusEFTPS = false;
          this.statusSalesTax = false;
          this.statusChecks = false;
          this.statusBooks = false;
          this.statusReportsPayroll = false;
          this.statusForms = false;
          this.statusOthers = false;
          this.statusTaxReturn = false;
          this.statusEmployee = false;
          this.statusCompanyInfo = false;
          break;

        case "Financial Statements":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.statusReports = true;
          this.statusEFTPS = false;
          this.tabla = false;
          this.statusSalesTax = false;
          this.statusChecks = false;
          this.statusBooks = false;
          this.statusReportsPayroll = false;
          this.statusForms = false;
          this.statusTaxReturn = false;
          this.statusOthers = false;
          this.statusEmployee = false;
          this.statusCompanyInfo = false;
          break;

        case "Payroll":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.tabla = false;
          this.statusEFTPS = false;
          this.statusBooks = false;
          this.statusChecks = false;
          this.statusEmployee = false;
          this.statusCompanyInfo = false;
          this.statusTaxReturn = false;
          this.$router.push("/Payroll").catch((failure) => {});
          break;

        case "Documents":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.tabla = false;
          this.statusChecks = false;
          this.statusBooks = false;
          this.statusEFTPS = false;
          this.statusEmployee = false;
          this.statusCompanyInfo = false;
          this.statusTaxReturn = false;
          this.$router.push("/DocumentosCliente").catch((failure) => {});
          break;

        case "Checks":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.statusOthers = false;
          this.statusChecks = true;
          this.statusSalesTax = false;
          this.statusReports = false;
          this.statusReportsPayroll = false;
          this.statusBooks = false;
          this.statusForms = false;
          this.statusEFTPS = false;
          this.statusCompanyInfo = false;
          this.statusEmployee = false;
          this.statusTaxReturn = false;
          break;

        case "Payroll Reports":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.statusReportsPayroll = true;
          this.statusSalesTax = false;
          this.statusReports = false;
          this.statusChecks = false;
          this.statusEFTPS = false;
          this.statusBooks = false;
          this.statusForms = false;
          this.statusOthers = false;
          this.statusTaxReturn = false;
          this.statusEmployee = false;
          this.statusCompanyInfo = false;
          break;

        case "Forms":
          this.statusVendors = false;
          this.statusForms = true;
          this.statusCompanyFolder = false;
          this.statusSalesTax = false;
          this.statusReports = false;
          this.statusChecks = false;
          this.statusReportsPayroll = false;
          this.statusEFTPS = false;
          this.statusBooks = false;
          this.statusOthers = false;
          this.statusTaxReturn = false;
          this.statusEmployee = false;
          this.statusCompanyInfo = false;

          break;
        case "Other":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.statusOthers = true;
          this.statusTaxReturn = false;
          this.statusSalesTax = false;
          this.statusBooks = false;
          this.statusReports = false;
          this.statusReportsPayroll = false;
          this.statusEFTPS = false;
          this.statusChecks = false;
          this.statusReportsPayroll = false;
          this.statusForms = false;
          this.statusEmployee = false;
          this.statusCompanyInfo = false;

          break;

        case "Employee":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.statusOthers = false;
          this.statusBooks = false;
          this.statusSalesTax = false;
          this.statusReports = false;
          this.statusEFTPS = false;
          this.statusTaxReturn = false;
          this.statusReportsPayroll = false;
          this.statusChecks = false;
          this.statusReportsPayroll = false;
          this.statusForms = false;
          this.statusCompanyInfo = false;
          this.statusEmployee = true;

          break;

        case "Taxes Return":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.statusOthers = false;
          this.statusSalesTax = false;
          this.statusBooks = false;
          this.statusReports = false;
          this.statusEFTPS = false;
          this.statusReportsPayroll = false;
          this.statusChecks = false;
          this.statusReportsPayroll = false;
          this.statusForms = false;
          this.statusEmployee = false;
          this.statusTaxReturn = true;
          this.statusCompanyInfo = false;

          break;

        case "Accounting Books":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.statusOthers = false;
          this.statusSalesTax = false;
          this.statusReports = false;
          this.statusReportsPayroll = false;
          this.statusEFTPS = false;
          this.statusChecks = false;
          this.statusReportsPayroll = false;
          this.statusForms = false;
          this.statusEmployee = false;
          this.statusTaxReturn = false;
          this.statusBooks = true;
          this.statusCompanyInfo = false;

          break;

        case "Company":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.statusCompanyInfo = true;
          this.statusOthers = false;
          this.statusSalesTax = false;
          this.statusBooks = false;
          this.statusEFTPS = false;
          this.statusReports = false;
          this.statusReportsPayroll = false;
          this.statusChecks = false;
          this.statusReportsPayroll = false;
          this.statusForms = false;
          this.statusEmployee = false;
          this.statusTaxReturn = false;
          this.statusBooks = false;
          break;


          case "EFTPS":
          this.statusCompanyFolder = false;
          this.statusVendors = false;
          this.statusCompanyInfo = false;
          this.statusOthers = false;
          this.statusSalesTax = false;
          this.statusBooks = false;
          this.statusEFTPS = true;
          this.statusReports = false;
          this.statusReportsPayroll = false;
          this.statusChecks = false;
          this.statusReportsPayroll = false;
          this.statusForms = false;
          this.statusEmployee = false;
          this.statusTaxReturn = false;
          this.statusBooks = false;
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style></style>
